import { createStore } from 'vuex'
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { auth, db } from '@/firebase';

export default createStore({
  state: {
    // Define your initial state here
    user: null,
    isAuthenticated: false,
    userData: null,
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    getUser: state => state.user,
    getUserData: state => state.userData,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
    },
    clearUser(state) {
      state.user = null;
      state.isAuthenticated = false;
    },
    setUserData(state, data) {
      state.userData = data;
    },
  },
  actions: {
    login({ commit }, user) {
      commit('setUser', user);
    },
    logout({ commit }) {
      commit('clearUser');
    },
    register({ commit }, user) {
      // Registration logic can be added here
      commit('setUser', user);
    },
    async fetchUserData({ commit }) {
      // Fetch user data from firestore db
      const docRef = doc(db, "users", auth.currentUser.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        commit('setUserData', docSnap.data());
        console.log("User data fetched successfully:", docSnap.data());
      } else {
        console.log("No such document!");
      }
      
    },
  },
  modules: {
  }
})
